// Scroll reveal — adds `.is-visible` to elements with the `data-reveal`
// attribute when they enter the viewport. Reusable across any section
// that wants a scroll-triggered animation; the CSS owns the actual
// motion, this module just owns the timing.
//
// Once a target becomes visible the observer unsubscribes so the class
// stays put — animations don't replay if the user scrolls back.

// Fire as soon as the element edges into view rather than waiting for a
// fraction of it — a percentage threshold (e.g. 0.3) misbehaves on elements
// taller than the viewport (common on mobile), where you'd have to scroll
// most of the section past before 30% is on screen. threshold 0 + a small
// negative bottom margin triggers just after the top enters, at any height.
const REVEAL_ROOT_MARGIN = '0px 0px -10% 0px';

export default function scrollReveal() {
    const targets = document.querySelectorAll('[data-reveal]');

    if (!targets.length) {
        return;
    }

    // No IntersectionObserver (very old browsers): skip the gate and
    // mark everything visible immediately so the final state renders.
    if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-visible'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0, rootMargin: REVEAL_ROOT_MARGIN },
    );

    targets.forEach((el) => observer.observe(el));
}
